import React, { createContext, useState, useEffect } from "react";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('en');
  const translations = {
  mr: {
    "footer-address-main": `अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ
पुढे सरकार गेस्ट हाऊस, त्र्यंबकेश्वर, नाशिक 422212
फोन: (02594) 234253 / 54, 234007`,
    "footer-address-dindori": `|| प्रधान सेवा केंद्र, श्री क्षेत्र दिंडोरी ||
श्री स्वामी समर्थ सेवा व आध्यात्मिक विकास केंद्र
दिंडोरी, तालुका: दिंडोरी, जिल्हा: नाशिक
पिन कोड नं.-422202
फोन नंबर - (02557) 221710
इमेल - contact@ma.dindoripranit.org`,
    "footer-get-involved": `मोफत अन्नदान, आरोग्य सेवा व शिक्षण कार्यक्रमांना मदत करा. आपले योगदान मंदिर, रुग्णालय चालवण्यासाठी व गाव विकासासाठी वापरले जाते.`,
    "footer-donate-now": "देणगी द्या",
    "footer-learn-more": "अधिक माहिती",
    "footer-get-involved-heading": "सहभाग करा"
  },
  en: {
    "footer-address-main": `Akhil BharatiyaShri Swami Samarth Gurupeeth
Behind Gov. Guest House, Trimbakeshwar, Nashik 422212
Phone: (02594) 234253 / 54, 234007`,
    "footer-address-dindori": `|| Pradhan Seva Kendra, Shri Kshetra Dindori ||
Shree Swami Samarth Seva & Spiritual Development Center
Dindori, Taluka: Dindori, District: Nashik
Pin Code: 422202
Phone: (02557) 221710
Email: contact@ma.dindoripranit.org`,
    "footer-get-involved": `Support free food distribution, health services, and education programs. Your contribution helps run temples, hospitals, and rural development initiatives.`,
    "footer-donate-now": "Donate Now",
    "footer-learn-more": "Learn More",
    "footer-get-involved-heading": "Get involved"
  }
};


  useEffect(() => {
    const storedLang = localStorage.getItem('app-lang');
    if (storedLang) setLang(storedLang);
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};
